import clsx from "clsx";
import React from "react";
import "./settingsFormRoot.scss";

interface ISettingsFormRootProps extends React.ComponentPropsWithoutRef<"div"> { }
export const SettingsFormRoot = (props: ISettingsFormRootProps) => {
    return <div {...props} className={clsx("settings-form-root", props.className)} />;
};
